/* ============
 * Admin Users Mutations Types
 * ============
 *
 * The mutations types available for the admin-users module.
 */

export const ALL = 'ALL';
export const NONE = 'NONE';
export const CREATED = 'CREATED';
export const UPDATED = 'UPDATED';
export const DESTROYED = 'DESTROYED';
export const SET_PATH = 'SET_PATH';
export const ADD_TO_PATH = 'ADD_TO_PATH';
export const SLICE_PATH = 'SLICE_PATH';
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM';
export const REMOVE_LAST_PATH_ITEM = 'REMOVE_LAST_PATH_ITEM';



// WEBPACK FOOTER //
// ./src/store/modules/admin-users/types.js